// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qk6Z","title":"styles_title__16tu1"};